var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7382 8.96973L4.00274 0.126533C3.90861 0.0549312 3.79718 0.0118599 3.68086 0.00211904C3.56453 -0.00762187 3.44789 0.0163495 3.34392 0.0713634C3.23996 0.126377 3.15275 0.210272 3.09203 0.313697C3.0313 0.417122 2.99945 0.536015 3.00001 0.657125V18.3435C3.00001 18.8823 3.58658 19.1867 4.00274 18.8741L15.7382 10.0309C15.8193 9.97033 15.8852 9.89062 15.9308 9.79837C15.9763 9.70612 16 9.60397 16 9.50033C16 9.39668 15.9763 9.29453 15.9308 9.20228C15.8852 9.11003 15.8193 9.03032 15.7382 8.96973Z",
    fill: "#2C4D52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.8c18dc973d0ec02fd9043468938f9f09.svg";
export { ForwardRef as ReactComponent };